
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Error handling for root level errors
const handleRootError = (error: Error) => {
  console.error('Root level error:', error);
  // You could also render a fallback UI here
};

// Remove any potential injected popup handlers
document.addEventListener('DOMContentLoaded', () => {
  // Find and remove any elements with class names containing 'lovable' or 'gpteng'
  const removeElements = () => {
    const elements = document.querySelectorAll('[class*="lovable"], [class*="gpteng"], [id*="lovable"], [id*="gpteng"]');
    elements.forEach(el => el.remove());
  };
  
  // Run immediately and periodically to catch any dynamically added elements
  removeElements();
  setInterval(removeElements, 1000);

  // Register performance measurement
  if ('performance' in window && 'PerformanceObserver' in window) {
    // Create performance observer
    const perfObserver = new PerformanceObserver((list) => {
      const entries = list.getEntries();
      entries.forEach((entry) => {
        // You can log or send these metrics to your analytics
        if (entry.entryType === 'largest-contentful-paint') {
          console.log('LCP:', entry.startTime);
        }
      });
    });

    // Observe LCP
    perfObserver.observe({ type: 'largest-contentful-paint', buffered: true });
  }
});

// Use createRoot API with error boundary
const rootElement = document.getElementById("root");

if (!rootElement) {
  console.error('Root element not found');
} else {
  try {
    const root = createRoot(rootElement);
    root.render(<App />);
  } catch (error) {
    handleRootError(error as Error);
  }
}
